export function calcTotalPrice(license, quantity) {
  let total = 0;

  // fixed price
  if (license.amount) {
    total = license.amount * quantity;
  }

  // tiers
  else if (license.tiers) {
    let previousTier = 0;
    for (const tier of license.tiers) {
      const tierNum = Math.min(quantity, tier.up_to || Infinity);
      total += (tierNum - previousTier) * tier.unit_amount;
      previousTier = tier.up_to;
      if (quantity < tier.up_to) break;
    }
  }

  return total;
}
